import { render, staticRenderFns } from "./BnplTransactionsTile.vue?vue&type=template&id=fa5e45fc&"
import script from "./BnplTransactionsTile.vue?vue&type=script&lang=js&"
export * from "./BnplTransactionsTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports